const outlineOffset = 2;
const outlineWidth = 2;

export { outlineOffset, outlineWidth };
//# sourceMappingURL=outlines.js.map
